import { Row,Card,Col,Typography,Button, Flex, Space, Table, Avatar, Tag } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { MessageOutlined } from "@ant-design/icons";
import { DeleteIcon, EditIcon } from "../../../../../assets/svg";
import { colors } from "../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../common/spinner/Spinner";
import styles from "./FlashMessageList.module.scss";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import { getFlashMessagesAction } from "../../../../../redux/services/flash-message/flashMessageServices";
import { dateObjToDispViewDate,timeObjToDispViewTimeWithSuffix } from "../../../../../utils/utils";
import FlashMessageFormDialog from "./FlashMessageFormDialog";
import FlashMessageDeleteDialog from "./FlashMessageDeleteDialog";
import { UserOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const FlashMessageList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const { flashMessages } = useSelector((state) => state.flashMessages);
  const [columns, setColumns] = useState([]);
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: flashMessages?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };

  /* dialog dependencies */
  const [openAddEditFlashMessageDialog, setOpenAddEditFlashMessageDialog] =
    useState(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const [flashMessageId, setFlashMessageId] = useState(null);

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: pagination?.pageNo,
      limit: pagination?.pageSize
    };
    dispatch(getFlashMessagesAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, [pagination]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Notify.title"),
        key: "title",
        render: (_, record) => {
          return (
            <Flex gap="1rem" align="center">
              <Avatar 
                shape="square" size={64}
              src={record?.coverimage} key={record?._id} icon={<UserOutlined />}/>
              {`${record.title}`}
            </Flex>
          );
        },
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          const getColorBasedOnStatus = (status) => {
            switch (status) {
              case true:
                return { background: colors.lightTeal, color: colors.darkTeal };
  
              case false:
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };
  
              default:
                break;
            }
          };
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  ...getColorBasedOnStatus(record?.is_active),
                  textTransform: "capitalize",
                }}
              >
                {record?.is_active === true ? t("CommonUtils.active") : t("CommonUtils.inactive")}
              </Tag>
            </>
          );
        },
      },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{`${dateObjToDispViewDate(record?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
        ),
      },
      {
        title: t("appointmentInfo.action"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
            {
              record?.is_active ?
              <Flex gap="small" justify="center">
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<EditIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleAddEditDetails(e, record)}
                  />
                </Space>
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<DeleteIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleConfirmDelete(e, record)}
                  />
                </Space>
              </Flex>
              :
              <>-</>
            }
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleAddEditDetails = (e, row) => {
    setOpenAddEditFlashMessageDialog(true);
    setFlashMessageId(row);
  };

  const handleConfirmDelete = (e, row) => {
    setFlashMessageId(row);
    setDeleteModal(true);
  };

  return (
    <div className={styles.flashMessageContainer}>
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">          
          <Card
                  bordered
                  hoverable
                  style={{
                    width: 300,
                    padding: 0,
                    borderRadius: 20,
                    border: `1px solid ${colors.oceanBlue}`,
                  }}
                >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={6}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    
                    icon={<MessageOutlined style={{ fontSize: 22 }} />}
                    style={{ background: colors.oceanBlue }}
                  />
                </Col>
                <Col span={18}>
                  <Flex vertical>
                    <Typography.Title level={3}>
                      {t("AppModuleNames.SuperAdmin.FlashMessage")}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.DarkMint }}
                    >
                      {`${flashMessages?.total || 0}`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>
            <Button type="primary" onClick={(e) => handleAddEditDetails(e, null)}>
          {t("AppModuleNames.SuperAdmin.AddFlashMessage")}
          </Button>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={flashMessages?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
      <FlashMessageFormDialog
        open={openAddEditFlashMessageDialog}
        onClose={() => {
          handleGetTableData();
          setOpenAddEditFlashMessageDialog(false);
        }}
        selectedListData={flashMessageId}
        setSelectedListData={setFlashMessageId}
      />
      <FlashMessageDeleteDialog
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        selectedFlashMessageId={flashMessageId?._id}
        callListApi={handleGetTableData}
      />
    </div>
  );
};

export default FlashMessageList;
